<template>
  <div>
    <va-card class="overflow-auto">
      <vue-element-loading :active="visible" :is-full-screen="true" />
      <div class="row">
        <div class="flex md6 sm6 xs12">
          <h4 style="font-size:24px!important" class="card-title mx-2">CRIME REPORTS</h4>
        </div>
      </div>
      <h5>*Select the options to filter the results</h5>
      <div class="row">
        <div class="flex md3 sm6 xs12">
          <div class="form-group">
            <label for="exampleInputEmail1" style="text-align: left!important;"></label>
            <select class="filter pt-2 pb-2" style="width:100%!important" v-model="usertype">
              <option value selected disabled hidden>User Type</option>
              <option v-bind:value="none">All</option>
              <option>user</option>
              <option>guest</option>
            </select>
          </div>
        </div>

        <div class="flex md3 sm6 xs12">
          <div class="form-group">
            <label for="exampleInputEmail1" style="text-align: left!important;"></label>
            <select class="filter pt-2 pb-2" style="width:100%!important" v-model="crimeType">
              <option value selected disabled hidden>Crime Type</option>
              <option v-bind:value="none">All</option>
              <option v-for="ct in ctype" :key="ct._id" v-bind:value="ct._id">{{ct.cname}}</option>
            </select>
          </div>
        </div>
        <div class="flex md3 sm6 xs12">
          <div class="form-group">
            <label for="exampleInputEmail1" style="text-align: left!important;"></label>
            <select class="filter pt-2 pb-2" style="width:100%!important" v-model="CRtype">
              <option value selected disabled hidden>Level of Reporting</option>
              <option v-bind:value="none">All</option>
              <option>online</option>
              <option>groundlevel</option>
            </select>
          </div>
        </div>
        <!-- <div class="flex md3 sm6 xs12">
          <div class="form-group">
            <label for="exampleInputEmail1" style="text-align: left!important;"></label>
            <select class="filter" v-model="source">
              <option value selected disabled hidden>Source</option>
              <option v-for="info in Sour" :key="info" v-bind:value="info._id">{{info.sname}}</option>
            </select>
          </div>
        </div>-->
        <div class="flex md3 sm6 xs12">
          <div class="form-group">
            <label for="exampleInputEmail1" style="text-align: left!important;"></label>
            <select class="filter pt-2 pb-2" style="width:100%!important" v-model="status">
              <option value selected disabled hidden>Status</option>
              <option v-bind:value="none">All</option>
              <option v-for="st in stat" :key="st">{{st}}</option>
            </select>
          </div>
        </div>
      </div>
      <div class="flex md12 sm6 xs12 overflow-auto">
        <div class="overflow-aut0" style="overflow:auto">
          <b-table
            hover
            v-if="data.length"
            class="table-sm th table-sm td"
            id="my-table"
            :fields="fields"
            :items="data"
            :per-page="perPage"
            :current-page="currentPage"
            small
            borderless
            head-variant="dark"
            table-variant="light"
          >
            <template v-slot:cell(_id)="data">
              <router-link :to="'/reportsview/'+data.item._id ">
                <b-button variant="success">View Details</b-button>
              </router-link>
            </template>
          </b-table>
          <p v-else>No Data Found</p>
          <br />
          <b-pagination
            align="center"
            v-model="currentPage"
            :total-rows="rows"
            :per-page="perPage"
            aria-controls="my-table"
          ></b-pagination>
          <br />
        </div>
      </div>
    </va-card>
  </div>
</template>

<script>
import axios from 'axios'
import VueElementLoading from 'vue-element-loading'
export default {
  components: {
    VueElementLoading,
  },
  data () {
    return {
      id1: '',
      msg: '',
      visible: false,
      perPage: '10',
      currentPage: 1,
      dat: [],
      fields: [
        {
          key: 'usertype',
          label: 'User Type',
          sortable: false,
          tdClass: 'pdngtblcol1 text-capitalize',
          thClass: ' pdngtblcol1',
          trclass: 'pdngtblhead',
        },
        {
          key: 'crimeType.cname',
          label: 'Crime Name',
          sortable: false,
          tdClass: 'text-capitalize',
          //  thClass:"pdngtblhead"
        },
        {
          key: 'CRtype',
          label: 'Level of Reporting',
          sortable: false,
          //  thClass:"pdngtblhead"
        },
        {
          key: 'status',
          sortable: false,
          tdClass: 'pdngtblcol text-capitalize',
          // thClass:"pdngtblhead"
        },
        // {
        //   key: "Action",
        //   sortable: false
        // },
        {
          label: ' ',
          key: '_id',
          sortable: false,
          //  thClass:"pdngtblhead",
          tdClass: 'tblbutton',
        },
      ],
      data: [],
      data1: [],
      usertype: '',
      CRtype: '',
      crimeType: '',
      source: '',
      status: '',
      stat: '',
      ctype: [],
      Sour: '',
    }
  },

  mounted: function () {
    this.getList()
    this.statview()
    this.crimeview()
    this.infoview()
  },
  computed: {
    rows () {
      return this.data.length
    },
  },
  watch: {
    crimeType: function () {
      this.getList()
    },
    status: function () {
      this.getList()
    },
    source: function () {
      this.getList()
    },
    usertype: function () {
      this.getList()
    },
    CRtype: function () {
      this.getList()
    },
  },

  methods: {
    crimeview () {
      this.visible = true
      axios({
        method: 'GET',
        url: '/crimetype/list',
      })
        .then(response => {
          this.ctype = response.data.data
          this.visible = false
        })

        .catch(err => {
          this.visible = false
          console.log(err)
        })
    },
    statview () {
      this.visible = true
      axios({
        method: 'GET',
        url: '/status/list',
      })
        .then(response => {
          this.stat = response.data.data
          this.visible = false
        })
        .catch(err => {
          this.visible = false
          console.log(err)
        })
    },
    infoview () {
      this.visible = true
      axios({
        method: 'POST',
        url: '/source/list',
      })
        .then(response => {
          this.Sour = response.data.data

          this.visible = false
        })
        .catch(err => {
          this.visible = false
          console.log(err)
        })
    },
    getList () {
      this.visible = true
      var data1 = {}
      if (this.usertype !== '') {
        data1['usertype'] = this.usertype
      }
      if (this.CRtype !== '') {
        data1['CRtype'] = this.CRtype
      }
      if (this.crimeType !== '') {
        data1['crimeType'] = this.crimeType
      }
      if (this.source !== '') {
        data1['source'] = this.source
      }
      if (this.status !== '') {
        data1['status'] = this.status
      }
      axios({
        method: 'POST',
        url: '/crimereports/all/list',
        data: data1,
        headers: {
          token: localStorage.getItem('token'),
        },
      })
        .then(response => {
          // console.log(response.data.data)
          //  this.posts = response.data.data;

          // this.data = response.data.data
          // this.crimeType = response.data.data.crimeType.cname
          for (var i = 0; i < this.data.length; i++) {
            var dt = this.data[i].create_date
            dt = new Date(dt)
            dt = dt.toString()
            dt = dt.slice(0, 15)
            this.data[i].create_date = dt
          }
          //  if (response.data.status === true ) {
          //   var temp={}
          //   for (var i = 0; i < this.data.length; i++) {
          //     if(response.data.data[1].status==='pending'){
          //           var ty = this.items1[i].photo;
          //   temp.push(ty);
          // }
          //     }
          //   }
          if (response.data.status === true) {
            this.data = response.data.data
            this.visible = false
          } else if (response.data.status === false) {
            this.visible = false

            // var temp = []

            // for (var j = 0; j < this.data.length; j++) {
            //   var ty = this.data[j].crimeType.cname

            //   temp.push(ty)
            // }
            // this.ctype = temp
          }
        })
        .catch(e => {
          console.log(e)
          this.visible = false
          // this.errors.push(e)
          this.msg = 'failed'
        })
    },
  },
}
</script>
<style scoped>
.pdngtblcol {
  padding-right: 50px !important;
}
.pdngtblcol1 {
  padding-left: 30px !important;
}

.pdngtblhead {
  padding-top: 30px !important;
  margin-top: 30px !important;
  padding-bottom: 30px !important;
}
.thead-dark {
  padding-top: 80px !important;
}
.table-sm th,
.table-sm td {
  padding: 30px !important;
}
.filter {
  width: 100% !important;
}
.tblbutton {
  text-align: right !important;
  width: 30% !important;
}
</style>
